export const CLOSE_PANEL = 'at/workSchedule/importHolidaysPanel/CLOSE_PANEL'
export const OPEN_PANEL = 'at/workSchedule/importHolidaysPanel/OPEN_PANEL'
export const YEAR_SET = 'at/workSchedule/importHolidaysPanel/YEAR_SET'
export const COUNTRY_SET = 'at/workSchedule/importHolidaysPanel/COUNTRY_SET'
export const HOLIDAYS_SET = 'at/workSchedule/importHolidaysPanel/HOLIDAYS_SET'
export const HOLIDAYS_IN_PAST_SET = 'at/workSchedule/importHolidaysPanel/HOLIDAYS_IN_PAST_SET'
export const LOAD_DATA = 'at/workSchedule/importHolidaysPanel/LOAD_DATA'
export const LOAD_DATA_SUCCESS = 'at/workSchedule/importHolidaysPanel/LOAD_DATA_SUCCESS'
export const LOAD_DATA_FAILURE = 'at/workSchedule/importHolidaysPanel/LOAD_DATA_FAILURE'
export const IMPORT_HOLIDAYS_START = 'at/workSchedule/importHolidaysPanel/IMPORT_HOLIDAYS_START'
export const IMPORT_HOLIDAYS_COMPLETE = 'at/workSchedule/importHolidaysPanel/IMPORT_HOLIDAYS_COMPLETE'



// WEBPACK FOOTER //
// ./web/js/administration/workSchedule/components/panels/importHolidays/actionTypes.js